// IMP-483: 로그인 화면 통합(/Login, /Admin/Login) — Admin 포털 전용 로그인 화면 구현을 제거하고
// 통합 화면(src/pages/auth/LoginPage.js) 을 그대로 재사용하는 얇은 별칭(alias) 모듈로 축소한다.
// 라우트(/Admin/Login)·북마크·pages/admin/index.js import 는 그대로 살아있어야 하므로
// 파일 자체는 삭제하지 않는다(프로젝트 규칙: 파일 삭제 금지 — soft 전환).
//
// resolveAdminLandingPath / resolvePostLoginPath 는 기존 호출부(예: resolveAdminLandingPath.test.js)
// 하위호환을 위해 loginLanding.js(SSoT) 에서 재export 한다.
import LoginPage from '../auth/LoginPage';
import { resolveLandingPath, resolvePostLoginPath } from '../../lib/loginLanding';

export const resolveAdminLandingPath = resolveLandingPath;
export { resolvePostLoginPath };

export default LoginPage;
